import { IdentitySettingsListItem } from '../../../integrated-client/models/';

export class ResultsData {
  items: Array<IdentitySettingsListItem>;
  totalItems?: number;
  showMore: boolean;

  constructor() {
    this.items = [];
    this.totalItems = 0;
    this.showMore = false;
  }

}
